// extracted by mini-css-extract-plugin
export var avatarContainer = "_9j-0";
export var avatarTypingWave = "_9j-i";
export var gray = "_9j-f";
export var green = "_9j-c";
export var icon = "_9j-9";
export var image = "_9j-1";
export var lg = "_9j-6";
export var md = "_9j-5";
export var presenceDot = "_9j-b";
export var red = "_9j-d";
export var sm = "_9j-4";
export var status = "_9j-a";
export var typingDot = "_9j-h";
export var typingPill = "_9j-g";
export var xl = "_9j-7";
export var xs = "_9j-3";
export var xxl = "_9j-8";
export var xxs = "_9j-2";
export var yellow = "_9j-e";